import { Breadcrumb, BreadcrumbData } from '../../components/Breadcrumbs';

export function PlaygroundPageCrumb(props: Partial<BreadcrumbData>) {
  return <Breadcrumb name="Playground" {...props} />;
}
